export enum MatchTypeEnum {
  EXACT_MATCH = <any>'Exact',
  PARTIAL_MATCH = <any>'Partial',
  NO_MATCH = <any>'NoMatch'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/match-type.enum.ts